export default __webpack_public_path__ + "locales/sr-Cyrl-RS/PrivacyPage.json?hash=571f0fd3ccb7730526d372de05470be6";